import React, { useEffect, useMemo, useState } from "react";
import { InputField, DataTable, DropDownInput, Button } from "@/components";
import ColumnHelper from "@/utils/ColumnHelper";
import { useFilteredData } from "@/";
import { getKycRequests } from "../../utils/Data";
import { useLocation, useNavigate } from "react-router-dom";
import { SpaceWrapper } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { fetchKycPendingData, selectAllCustomers } from "../../app/Slices";

const KycRequests = () => {
  const [resetPageCounter, setResetPageCounter] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fetchData = async () => {
    const response = await dispatch(fetchKycPendingData());
    console.log("response::::::", response);
  };
  useEffect(() => {
    fetchData();
  }, [dispatch]);

  const kycs = useSelector(selectAllCustomers) || [];
  console.log("KycPendings", kycs);
  const handleView = (info) => {
    navigate("/customer/details/" + info);
    console.log("info", info);
  };
  const columns = useMemo(
    () => [
      ColumnHelper({
        header: "Customer Name",
        accessorKey: "",
        cell: (info) => info.row.original.userId?.name || "N/A",
        meta: {
          tooltip: (row) => row.userId?.name || "N/A",
        },
      }),
      ColumnHelper({
        header: "Customer ID",
        accessorKey: "clientId",
        meta: {
          tooltip: (row) => row.clientId || "N/A",
        },
      }),
      ColumnHelper({
        header: "Mobile No",
        accessorKey: "",
        cell: (info) =>
          info.row.original.personalDetails?.phone?.[0]?.phoneNumber || "N/A",
        meta: {
          tooltip: (row) =>
            row.personalDetails?.phone?.[0]?.phoneNumbe || "N/A",
        },
      }),
      ColumnHelper({
        header: "Firm Name",
        accessorKey: "",
        cell: (info) => info.row.original.businessDetails?.firmName || "N/A",
        meta: {
          tooltip: (row) => row.businessDetails?.firmName || "N/A",
        },
      }),
      ColumnHelper({
        header: "Gst No",
        accessorKey: "",
        cell: (info) => info.row.original.businessDetails?.gstNumber || "N/A",
        meta: {
          tooltip: (row) => row.businessDetails?.gstNumber || "N/A",
        },
      }),
      ColumnHelper({
        header: "Action",
        accessorKey: "",
        cell: (info) => (
          <div className="flex gap-1">
            <Button
              size="xs"
              onClick={() => handleView(info.row.original.userId?._id)}
            >
              View
            </Button>
          </div>
        ),
        meta: {
          tooltip: () => "View or block customer",
        },
      }),
    ],
    []
  );

  const data = useMemo(() => getKycRequests(100), []);

  return (
    <SpaceWrapper>
      <div className="w-full flex-1 flex flex-col gap-4 p-4 pb-20 md:pb-4 relative max-w-[2000px]">
        <div className="w-full md:w-[60%] flex flex-col gap-2">
          <h1 className="text-headline4 lg:text-headline3 font-nunito text-secondary/95 font-bold">
            KYC Requests
          </h1>
          <p className="text-body2 md:text-body1 text-secondary/60">
            Review and verify customer identity documents to ensure secure
            transactions, prevent fraud, and maintain compliance with regulatory
            requirements.
          </p>
        </div>
        <DataTable
          columns={columns}
          tittle="KYC Requests"
          data={kycs}
          resetPage={resetPageCounter}
          showCheckbox={false}
        />
      </div>
    </SpaceWrapper>
  );
};

export default KycRequests;
